import React, { useEffect, useState } from 'react';
import { Box, Button, List, ListItem, Stack, Typography, useMediaQuery } from '@mui/material';
import { Circle } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
// import EirOfferCardBodyDescription from './EirOfferCardBodyDescription';
// import EirOfferCardBodyCta from './EirOfferCardBodyCta';
// import IconButton from '@mui/material/IconButton';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
// import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
// import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import StyledCardContent from './CardContent.styled';

// import useLocalStorage from '../../hooks/useLocalStorage';
// import RootContext from '../../../util/root.context';
import EirLoader from '../eir-loader/EirLoader';
import EirOfferCardBodySkeleton from './EirOfferCardBodySkeleton';
import { calculateSlideCardColor } from '../../../util/offerColorCalculator';
import styles from './styles';
import getGeneralImage from '../../../util/getGeneralImage';

const { publicRuntimeConfig } = getConfig();

const EirOfferCardBody = ({
  title,
  price,
  afterPrice,
  afterPricePosition,
  noDiscount,
  contractLength,
  description,
  descriptions,
  openDialog,
  priceIncreaseTagline = [''],
  selectButton,
  style,
  offerSelected,
  index,
  offer,
  code,
  showLoader,
  loading,
  // showCounter = false,
  // offerCount,
  // onOfferSelect,
  // onOfferUnSelect,
  // allowedToAdd = false,
  isMbb,
  isAddon,
  isTv = false,
  isMobile = false,
  isBroadband = false,
  // handsetPrice,
  offerCardButtonDisable = false,
  slideNumber,
  handsetPrice,
  cmsData,
}) => {
  // const localStore = useLocalStorage();
  const [priceData, setPriceData] = useState('');
  const [price1, price2] = priceData;
  // const { state: rootState, dispatch } = useContext(RootContext);
  const handleOfferButton = () => {
    selectButton.action(index, offer);
  };
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    if (price) {
      setPriceData(price.toString().split('.'));
    }
  }, [price]);

  const setEqualHeight = () => {
    const getParentRef = document.querySelector('#offerCardData');
    const content = getParentRef.querySelectorAll('.offerCardBody');
    const Array = [];

    for (let i = 0; i < content.length; i += 1) {
      content[i].style.height = 'unset';
    }

    for (let i = 0; i < content.length; i += 1) {
      Array.push(parseInt(content[i].clientHeight, 10));
    }

    for (let i = 0; i < content.length; i += 1) {
      content[i].style.height = `${Math.max(...Array) + 10}px`;
    }
  };
  useEffect(() => {
    if (loading === false) setEqualHeight(document);
  }, [loading]);

  return (
    <StyledCardContent
      className='offerCardBody'
      sx={{
        ...{
          display: 'flex',
          minHeight: '100%',
          flex: 1,
          justifyContent: 'center',
          p: '1.5rem',
          background: theme.palette.secondary.bundleCardBodyBackground,
        },
        ...(isTv ? style.offerCardBodyTV : style.offerCardBody),
        ...(loading && { p: 0 }),
      }}
    >
      {!loading ? (
        <Box
          className='offerBody'
          sx={{
            ...(isTv ? style.offerBodyTV : style.offerBody),
            ...{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            },
            pb: '1.5rem',
          }}
        >
          {(isAddon || isTv) && title && (
            <Typography variant='h4' sx={styles(theme).offerTitle}>
              {title}
            </Typography>
          )}
          <Stack sx={{ ...style?.container, flex: 1 }} justifyContent='space-between'>
            <Box sx={{ flex: 1 }}>
              {/* price */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '3%',
                  height: '2.5rem',
                }}
              >
                <>
                  <Box>
                    {isTv ? (
                      <Typography
                        component='span'
                        variant='h3'
                        sx={
                          isBroadband
                            ? {
                                ...style.priceOne,
                                color: theme.palette.primary.textColor3,
                              }
                            : style.priceOne
                        }
                        // className='swiper-no-swiping'
                      >
                        {price1 ? `+ €${price1}` : ''}
                      </Typography>
                    ) : (
                      <Typography
                        component='span'
                        variant='h3'
                        sx={
                          isBroadband || isMbb
                            ? {
                                ...style.priceOne,
                                color: theme.palette.primary.textColor3,
                              }
                            : style.priceOne
                        }
                        // className='swiper-no-swiping'
                      >
                        {price1 ? `€${price1}` : ''}
                      </Typography>
                    )}
                    <Typography
                      component='span'
                      variant='h3'
                      sx={
                        isBroadband || isMbb
                          ? {
                              ...style.priceOne,
                              color: theme.palette.primary.textColor3,
                            }
                          : style.priceOne
                      }
                      // className='swiper-no-swiping'
                    >
                      {price2 ? `.${price2}` : ''}
                    </Typography>
                  </Box>
                  {/* contract length */}
                  {!noDiscount && contractLength && (
                    <Typography variant='body1' component='p' sx={style?.contractText}>
                      {contractLength}
                    </Typography>
                  )}
                  {noDiscount && (
                    <>
                      <Typography variant='body1' component='p' sx={style?.contractText}>
                        a month
                      </Typography>
                      {/* {isMbb && isMobile && (
                    <Typography component='p' sx={style?.contractText}>
                      for {discountDuration} months
                    </Typography>
                  )} */}
                    </>
                  )}
                  {/* promotion texts
                  {!noDiscount && afterPrice && afterPricePosition === '' && (
                    <Typography component='p' sx={style?.promotionText}>
                      {afterPrice}
                    </Typography>
                  )}
                  {noDiscount && (
                    <>
                      <Typography component='p' sx={style?.contractText}>
                        a month
                      </Typography>
                      {isMbb && (
                        <Typography component='p' sx={style?.contractText}>
                          for {discountDuration} months
                        </Typography>
                      )}
                    </>
                  )} */}
                </>
              </Box>
              {/* promotion texts */}
              {!noDiscount && afterPrice && afterPricePosition === '' ? (
                <Typography component='p' sx={style?.promotionText}>
                  {afterPrice}
                </Typography>
              ) : (
                ''
              )}

              {/* button */}
              {priceIncreaseTagline?.length > 0 && (
                <Box
                  sx={{
                    paddingLeft: md ? '1rem' : '2rem',
                    paddingRight: md ? '1rem' : '2rem',
                    display: 'flex',
                  }}
                >
                  <Typography
                    variant='body2'
                    sx={{
                      color: theme.palette.primary.textColor3,
                      textAlign: 'left',
                      fontSize: '12px',
                    }}
                    dangerouslySetInnerHTML={{ __html: priceIncreaseTagline[0] }}
                  />
                </Box>
              )}

              {/* {showCounter &&
                offerCount > 0 &&
                localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'true' && (
                  <Typography component='p' sx={style?.addedSimText} className='swiper-no-swiping'>
                    <strong>{offerCount} ×</strong> Plan already added
                  </Typography>
                )} */}
              {/* description */}
              {description.length > 0 && (
                <Stack
                  direction='row'
                  sx={{
                    background: theme.palette.secondary.contrastText,
                    borderRadius: '6px',
                    alignItems: 'center',
                    gap: '3%',
                    marginTop: '1.5rem',
                    height: '38px',
                  }}
                >
                  <Box
                    component='img'
                    src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
                      getGeneralImage({
                        generalImageArray: cmsData?.GeneralImage_Broadband,
                        key: 'giftIcon',
                        view: 'DesktopViewImage',
                      }).url
                    }`}
                    alt='gift Icon'
                    style={{ width: '20px', height: '20px', marginLeft: '1rem' }}
                  />

                  <Typography variant='body2' component='p' sx={style?.description}>
                    <span dangerouslySetInnerHTML={{ __html: description }} />
                  </Typography>
                </Stack>
              )}
              {/* description list */}
              {descriptions?.length > 0 && (
                <List
                  sx={
                    !isTv
                      ? {
                          ...style?.descriptionList,
                          ...(priceIncreaseTagline.length > 0 && { paddingBottom: '0rem' }),
                        }
                      : { pl: { xs: '1rem' }, pr: { xs: '0.5rem' } }
                  }
                  dense
                >
                  {descriptions.map((list, i) => (
                    <ListItem
                      key={i}
                      sx={
                        list.icon
                          ? {
                              ...style?.descriptionList?.item,
                              ...(isTv && { pl: '1rem' }),
                              ...{ pb: '10px' },
                            }
                          : {
                              ...style?.descriptionList?.item,
                              ...style?.descriptionList?.item.dots,
                              color: calculateSlideCardColor({ slideNumber, theme }),
                              ...{ pb: '10px' },
                            }
                      }
                    >
                      <Stack direction='row' alignItems='center' sx={{ width: '100%' }}>
                        {list.icon ? (
                          <Box
                            className='item-icon'
                            component='img'
                            src={list.icon}
                            alt=''
                            sx={{
                              height: 32,
                              width: 32,
                            }}
                          />
                        ) : (
                          <Circle
                            sx={{
                              height: 5,
                              width: 5,
                              color: theme.palette.primary.offermain,
                              mt: '9.5px',
                            }}
                          />
                        )}
                        {list?.value.includes('tvChannelPopup') ? (
                          <Typography
                            component='p'
                            variant='body1'
                            className='text-item '
                            sx={{ pl: 1 }}
                            onClick={() => {
                              openDialog();
                            }}
                          >
                            <span dangerouslySetInnerHTML={{ __html: list?.value }} />
                            {/* {list?.value} */}
                          </Typography>
                        ) : (
                          <Typography
                            variant='body1'
                            component='p'
                            className='text-item '
                            sx={{ pl: 1, color: theme.palette.primary.textColor3 }}
                          >
                            <span dangerouslySetInnerHTML={{ __html: list?.value }} />
                            {/* {list?.value} */}
                          </Typography>
                        )}
                      </Stack>
                    </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Stack>
          <Box sx={{ pl: isTv ? '1.5rem' : 0, pr: isTv ? '1.5rem' : 0 }}>
            {handsetPrice?.length > 0 && handsetPrice >= 0 && (
              <Typography variant='body1' sx={{ ...styles(theme).brandPriceText }}>
                Phone cost:&nbsp;
                {handsetPrice[0] === 0 ? (
                  <Typography variant='subtitle1' component='p' sx={styles(theme).brandPrice}>
                    Free
                  </Typography>
                ) : (
                  <Typography variant='subtitle1' component='p' sx={styles(theme).brandPrice}>
                    {`€${(handsetPrice / 100).toFixed()}`}
                  </Typography>
                )}
              </Typography>
            )}
            {!(showLoader === code) && selectButton && (
              <Button
                onClick={handleOfferButton}
                disabled={offerCardButtonDisable}
                variant='buttonMedium'
                aria-label={offerSelected ? `${title} plan selected` : `Select ${title} plan`}
                sx={{
                  // ...{ mt: '1.5rem' },
                  ...(handsetPrice?.length > 0 && handsetPrice >= 0
                    ? { mt: '1.5rem' }
                    : { mt: '0.875rem' }),
                  ...style?.selectButton,
                  ...(offerSelected ? style.ctaSelected : {}),
                  // ...(offerCardButtonDisable && style.ctaDisabled),
                }}
              >
                {!offerSelected ? selectButton?.title : 'Selected'}
                {offerSelected ? <CheckCircleOutlineOutlinedIcon sx={style.ctaCheck} /> : ''}
              </Button>
            )}
            {isMobile
              ? showLoader === code && (
                  <EirLoader loaderTitle='Adding' buttonSize={{ width: '100% !important' }} />
                )
              : showLoader === code && (
                  <EirLoader
                    loaderTitle={!offerSelected ? 'Adding' : 'Removing'}
                    buttonSize={{ width: '100% !important' }}
                  />
                )}
          </Box>
        </Box>
      ) : (
        <EirOfferCardBodySkeleton />
      )}
    </StyledCardContent>
  );
};

export default EirOfferCardBody;
